import React from 'react';
import { STATUS_LABEL, QUOTE_STATUS_LABEL } from '../lib/format';

// One badge component for both booking and quote statuses. The colour is driven
// by the status string via CSS class, so a new status added on the server shows up
// as a neutral badge rather than an invisible one.
export default function StatusBadge({ status, kind = 'booking' }) {
  const label = (kind === 'quote' ? QUOTE_STATUS_LABEL : STATUS_LABEL)[status] || status;
  return <span className={`badge badge-${status}`}>{label}</span>;
}
